import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IAppBootstrapState } from './types';

const initState = {
  isLoading: false,
};

function onAppBootstrap(state: IAppBootstrapState) {
  return { ...state, isLoading: true };
}

function onAppBootstrapSuccess(state: IAppBootstrapState) {
  return { ...state, isLoading: false };
}

function onAppBootstrapError(state: IAppBootstrapState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.APP_BOOTSTRAP]: onAppBootstrap,
  [actions.APP_BOOTSTRAP_SUCCESS]: onAppBootstrapSuccess,
  [actions.APP_BOOTSTRAP_ERROR]: onAppBootstrapError,
});
